import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import {
  GET_OFFER_LIST_REQUEST,
  ADD_OFFER_REQUEST,
  UPDATE_OFFER_BY_OFFER_ID_REQUEST,
  UPDATE_OFFER_STATUS_BY_OFFER_ID_REQUEST,
  DELETE_OFFER_BY_OFFER_ID_REQUEST,
} from "./actionTypes";
import {
  getOfferListResponse,
  addOfferResponse,
  updateOfferByOfferIdResponse,
  updateOfferStatusByOfferIdResponse,
  deleteOfferByOfferIdResponse,
} from "./actions";

import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";
function* getOfferList() {
  try {
    const response = yield call(invokeApi, "get", "/OfferDetail", "");
    yield put(getOfferListResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* addOffer({ payload: { data } }) {
  try {
    const response = yield call(invokeApi, "post", "/OfferDetail", data);
    // if (response.isSuccessResponse) {
    //     yield put(getOfferListRequest());
    // }
    yield put(addOfferResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateOfferByOfferId({ payload: { offerId, data } }) {
  try {
    const response = yield call(
      invokeApi,
      "put",
      "/OfferDetail/" + offerId,
      data
    );
    yield put(updateOfferByOfferIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* deleteOfferByOfferId({ payload: { offerId } }) {
  try {
    const response = yield call(invokeApi, "delete", "/OfferDetail/" + offerId);
    yield put(deleteOfferByOfferIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateOfferStatusByOfferId({ payload: { offerId, status } }) {
  try {
    const response = yield call(
      invokeApi,
      "patch",
      "/OfferDetail/" + offerId + "/" + status
    );
    yield put(updateOfferStatusByOfferIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchOfferDetail() {
  yield takeEvery(GET_OFFER_LIST_REQUEST, getOfferList);
  yield takeEvery(ADD_OFFER_REQUEST, addOffer);
  yield takeEvery(UPDATE_OFFER_BY_OFFER_ID_REQUEST, updateOfferByOfferId);
  yield takeEvery(DELETE_OFFER_BY_OFFER_ID_REQUEST, deleteOfferByOfferId);
  yield takeEvery(
    UPDATE_OFFER_STATUS_BY_OFFER_ID_REQUEST,
    updateOfferStatusByOfferId
  );
}

function* offerDetailSaga() {
  yield all([fork(watchOfferDetail)]);
}

export default offerDetailSaga;
